import './App.css';
import ScrollToTop from "./Utils/scrollToTop";

import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useLayoutEffect, useState  } from 'react';
import Home from './Home/Home';
import Profile from './Profile/Profile';
import Research from './Research/Research';
import Projects from './Projects/Projects';
import Blog from './Blog/Blog';
import Gallery from './Gallery/Gallery';
import { createBrowserHistory } from 'history';
import CVMP2023 from './Research/CVMP2023';
import CVMP2024 from './Research/CVMP2024';
import SPIE2025 from './Research/SPIE2025';
import IC3D2021 from './Research/IC3D2021';
import ELFI2024 from './Research/ELFI2024';
import ICIP2026 from './Research/ICIP2026';
import Passport from './Blog/Passport';
import Publications from './Blog/Publications';

import ERZ from './Projects/Datasets/ERZ';
import EVA from './Projects/Datasets/EVA';
import ADAM from './Projects/Datasets/ADAM';
import HueBedroom from './Projects/Datasets/HueBedroom';
import ColorTransfer from './Projects/Datasets/ColorTransfer';
import Evermotion from './Projects/Datasets/Evermotion';
import EDEN1 from './Projects/Datasets/EDEN1';
import Sunlit3D from './Projects/Datasets/Sunlit3D';
import IDD from './Projects/Datasets/IDD';
import CTPublication from './Projects/Datasets/CTPublication';

import MoVeKI2EAH from './Projects/FundedProjects/MoVeKI2EAH';
import SSR from './Projects/FundedProjects/SSR';
import FlyCamXR from './Projects/FundedProjects/FlyCamXR';
import FAUstairs from './Projects/FundedProjects/FAUstairs';

import MLR from './Projects/Teaching/MLR';
import Clustering from './Projects/Teaching/Clustering';
import DimensionReduction from './Projects/Teaching/DimensionReduction';
import GAN from './Projects/Teaching/GAN';
import AISeminar from './Projects/Teaching/AISeminar';
import GANSeminar from './Projects/Teaching/GANSeminar';

import ColorTransferLab from './Projects/Applications/ColorTransferLab';
import ColorTransferLib from './Projects/Applications/ColorTransferLib';
import ImmerseDecorVR from './Projects/Applications/ImmerseDecorVR';
import RayVisualizer from './Projects/Applications/RayVisualizer';
import PointCloudLabelingTool from './Projects/Applications/PointCloudLabelingTool';
import SsrDemoTool from './Projects/Applications/SsrDemoTool';
import DJIVisualizer from './Projects/Applications/DJIVisualizer';
import Blank from './Projects/Applications/Blank';


const useWindowSize = () => {
  const [size, setSize] = useState([0, 0]);
  useLayoutEffect(() => {
    const updateSize = () => {
      setSize([window.innerWidth, window.innerHeight]);
    };
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);
  return size;
};

function App() {
  useWindowSize();
  return (
  
    <BrowserRouter basename="/Home">
    <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/Profile" element={<Profile/>} />
        <Route path="/Research" element={<Research/>} />
        <Route path="/Projects" element={<Projects/>} />
        <Route path="/Gallery" element={<Gallery/>} />
        <Route path="/Blog" element={<Blog/>} />


        <Route path="/Research/CVMP2024" element={<CVMP2024/>} />
        <Route path="/Research/SPIE2025" element={<SPIE2025/>} />
        <Route path="/Research/ELFI2024" element={<ELFI2024/>} />
        <Route path="/Research/CVMP2023" element={<CVMP2023/>} />
        <Route path="/Research/IC3D2021" element={<IC3D2021/>} />
        <Route path="/Research/ICIP2026" element={<ICIP2026/>} />

        <Route path="/Projects/Datasets/EVA" element={<EVA/>} />
        <Route path="/Projects/Datasets/ERZ" element={<ERZ/>} />
        <Route path="/Projects/Datasets/ADAM" element={<ADAM/>} />
        <Route path="/Projects/Datasets/EDEN1" element={<EDEN1/>} />
        <Route path="/Projects/Datasets/Sunlit3D" element={<Sunlit3D/>} />
        <Route path="/Projects/Datasets/IDD" element={<IDD/>} />
        <Route path="/Projects/Datasets/HueBedroom" element={<HueBedroom/>} />
        <Route path="/Projects/Datasets/ColorTransfer" element={<ColorTransfer/>} />
        <Route path="/Projects/Datasets/Evermotion" element={<Evermotion/>} />
        <Route path="/Projects/Datasets/CTPublication" element={<CTPublication/>} />

        <Route path="/Projects/FundedProjects/MoVeKI2EAH" element={<MoVeKI2EAH/>} />
        <Route path="/Projects/FundedProjects/SSR" element={<SSR/>} />
        <Route path="/Projects/FundedProjects/FlyCamXR" element={<FlyCamXR/>} />
        <Route path="/Projects/FundedProjects/FAUstairs" element={<FAUstairs/>} />
        <Route path="/Projects/Teaching/MLR" element={<MLR/>} />
        <Route path="/Projects/Teaching/Clustering" element={<Clustering/>} />
        <Route path="/Projects/Teaching/DimensionReduction" element={<DimensionReduction/>} />
        <Route path="/Projects/Teaching/GAN" element={<GAN/>} />
        <Route path="/Projects/Teaching/AISeminar" element={<AISeminar/>} />
        <Route path="/Projects/Teaching/GANSeminar" element={<GANSeminar/>} />

        <Route path="/Projects/Applications/ColorTransferLab" element={<ColorTransferLab/>} />
        <Route path="/Projects/Applications/ColorTransferLib" element={<ColorTransferLib/>} />
        <Route path="/Projects/Applications/ImmerseDecorVR" element={<ImmerseDecorVR/>} />
        <Route path="/Projects/Applications/RayVisualizer" element={<RayVisualizer/>} />
        <Route path="/Projects/Applications/PointCloudLabelingTool" element={<PointCloudLabelingTool/>} />
        <Route path="/Projects/Applications/SsrDemoTool" element={<SsrDemoTool/>} />
        <Route path="/Projects/Applications/DJIVisualizer" element={<DJIVisualizer/>} />
        <Route path="/Projects/Applications/Blank" element={<Blank/>} />


        <Route path="/Blog/Passport" element={<Passport/>} />
        <Route path="/Blog/Publications" element={<Publications/>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;

export const history = createBrowserHistory({
  basename: process.env.PUBLIC_URL
});